/**
 * DataStep.jsx
 * ============
 * Data table creation for setup wizard
 */

import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import SetupWizard from './SetupWizard';
import DataManagementPage from '../DataManagement/DataManagementPage';

const DataStep = () => {
  const { appName } = useParams();
  const [searchParams] = useSearchParams();

  return (
    <SetupWizard currentStepKey="data">
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        border: '1px solid #E5E7EB',
        padding: '32px'
      }}>
        <h2 style={{
          fontSize: '24px',
          fontWeight: '700',
          color: '#111827',
          marginBottom: '8px'
        }}>
          💾 Setup Data Storage
        </h2>
        <p style={{
          fontSize: '14px',
          color: '#6B7280',
          marginBottom: '24px'
        }}>
          Create tables to store information collected from forms and user interactions.
        </p>

        <div style={{
          padding: '24px',
          backgroundColor: '#F9FAFB',
          borderRadius: '8px',
          marginBottom: '24px'
        }}>
          <h3 style={{
            fontSize: '16px',
            fontWeight: '600',
            color: '#111827',
            marginBottom: '12px'
          }}>
            💡 Quick Tips:
          </h3>
          <ul style={{
            fontSize: '14px',
            color: '#6B7280',
            margin: 0,
            paddingLeft: '20px'
          }}>
            <li>Create a table for each form in your app</li>
            <li>Column names should match your form field names</li>
            <li>You can add sample data for testing</li>
            <li>Skip this step if you're just building a display-only website</li>
          </ul>
        </div>

        {/* Embed DataManagement */}
        <div style={{ marginTop: '24px' }}>
          <DataManagementPage appName={appName} />
        </div>
      </div>
    </SetupWizard>
  );
};

export default DataStep;
























